import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Stack,
  Circle,
  HStack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const TokenomicsCard = ({
  label,
  title,
  description,
}: {
  label: string;
  title: string;
  description: string;
}) => {
  return (
    <Stack
      spacing={4}
      p={6}
      bg="oxygon.dark.200"
      rounded="xl"
      border="1px solid"
      borderColor="oxygon.dark.300"
      _hover={{
        borderColor: "oxygon.primary",
        transform: "translateY(-5px)",
      }}
      transition="all 0.3s"
      position="relative"
      data-aos="fade-up"
    >
      <HStack>
        <Circle size="40px" bg="oxygon.primary" color="black" fontWeight="bold">
          {label}
        </Circle>
        <Heading size="md">{title}</Heading>
      </HStack>
      <Text color="gray.400">{description}</Text>
    </Stack>
  );
};

const Tokenomics = () => {
  return (
    <Box py={20} bg="oxygon.dark.200" position="relative" overflow="hidden">
      {/* Animated triangle background elements */}
      <MotionBox
        position="absolute"
        top="10%"
        left="-5%"
        width="300px"
        height="300px"
        borderRight="2px solid"
        borderColor="oxygon.secondary"
        transform="rotate(45deg)"
        opacity={0.05}
        animate={{
          rotate: [45, 90, 45],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear",
        }}
      />

      <Container maxW="container.xl" position="relative">
        <Stack spacing={12}>
          <Stack textAlign="center" spacing={4} data-aos="fade-up">
            <Heading
              bgGradient="linear(to-r, oxygon.primary, oxygon.secondary)"
              bgClip="text"
            >
              Who VGS Is For
            </Heading>
            <Text color="gray.400" maxW="800px" mx="auto">
              Built for simulator golfers, venues, communities, and anyone who
              wants structured competition.
            </Text>
          </Stack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing={8}>
            <TokenomicsCard
              label="01"
              title="Home simulator owners"
              description="Golfers playing at home who want real competition, structure, and community."
            />
            <TokenomicsCard
              label="02"
              title="Indoor golf venues & schools"
              description="Facilities that want leagues, tournaments, and persistent player profiles without building their own tech stack."
            />
            <TokenomicsCard
              label="03"
              title="Content creators & communities"
              description="YouTubers, streamers, and groups that want structured challenges and events for their audiences."
            />
            <TokenomicsCard
              label="04"
              title="Competitive friend groups"
              description="Friends who love to compete and want something better than a shared spreadsheet to track scores."
            />
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
};

export default Tokenomics;
